import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Common/Header';
import { SideBar } from '../Common/SideBar';
import { SecondNav } from '../Common/SecondNav';
import Profile from '../../Models/Profile'
import Modal from 'react-modal';
import axios from 'axios';
import { Footer } from '../Common';
var striptags = require('striptags');
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';
const customStyles = {
    content: {
        position:'absolute',
        top: '59%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
//   Modal.setAppElement('#yourAppElement')

class EditProfileNav extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);

        this.state = {
            minHeight: "475px",
            modalIsOpen: false,
            user: logged_user,
            profession: '',
            photo_id: null,
            utility: null,
            residential: [],
            services: [],
            portfolio: [],
            sex: [],
            area: '',
            address: '',
            x: '',
            profile_picture: null,
            profile: [],
            username: '',
            phone: '',
            email: '',
            creditcard: '',
            t_account: '',
            personal_text: '',

            bank_name: '',
            branch_name: '',
            account_name: '',
            account_type: ''
        };

        this.openModal = this.openModal.bind(this);
        // this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        Profile.getServiceList(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ services: res.data.payload })
            }
        })
        Profile.getPortfolio(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ portfolio: res.data.payload })
            }
        })
        Profile.getResidentials().then(res => {
            if (res.data.area != null) {
                this.setState({ residential: res.data.area })
            }
        })
        Profile.getSex().then(res => {
            if (res.data.sex != null) {
                this.setState({ sex: res.data.sex })
            }
        })
        Profile.getBasics(this.state.user.id).then(res => {
            if (res.data.payloads != null) {
                this.setState({ profile: res.data.payloads })
                if (res.data.payloads.profession !== 'null')
                    this.setState({ profession: res.data.payloads.profession })
                this.setState({ photo_id: res.data.payloads.pid })
                this.setState({ profile_picture: res.data.payloads.img })
                this.setState({ utility: res.data.payloads.ut })
                this.setState({ x: res.data.payloads.sex })
                if (res.data.payloads.residential_area !== 'null')
                    this.setState({ area: res.data.payloads.residential_area })
                if (res.data.payloads.address !== 'null')
                    this.setState({ address: res.data.payloads.address })
                if (res.data.payloads.personal_details !== 'null')
                    this.setState({ personal_text: res.data.payloads.personal_details })
            }
        })
        Profile.getConfiguration(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ username: res.data.payload.first_name })
                if (res.data.payload.phone !== 'null')
                    this.setState({ phone: res.data.payload.phone })
                if (res.data.payload.email !== 'null')
                    this.setState({ email: res.data.payload.email })
                if (res.data.payload.credit_card !== 'null')
                    this.setState({ creditcard: res.data.payload.credit_card })
                if (res.data.payload.transfer_account !== 'null')
                    this.setState({ t_account: res.data.payload.transfer_account })
                if (res.data.payload.bank_name != 'null') {
                    if (res.data.payload.bank_name !== " ") {
                        this.setState({ bank_name: res.data.payload.bank_name })
                    }
                }

                if (res.data.payload.branch_name != 'null') {
                    if (res.data.payload.branch_name !== " ") {
                        this.setState({ branch_name: res.data.payload.branch_name })
                    }
                }
                if (res.data.payload.account_name != 'null') {
                    if (res.data.payload.account_name !== " ") {
                        this.setState({ account_name: res.data.payload.account_name })
                    }
                }
                if (res.data.payload.account_type == 'general') {
                    this.setState({ account_type: '1' })
                } else if (res.data.payload.account_type == 'current') {
                    this.setState({ account_type: '2' })
                } else {
                    this.setState({ account_type: '3' })
                }
            }
        })
    }


    onChange(e) {
        this.setState({ photo_id: e.target.files[0] })
    }

    onChange_ut(e) {
        this.setState({ utility: e.target.files[0] })
    }

    onChangePro(e) {
        this.setState({ profile_picture: e.target.files[0] })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    updateValueNumber(type, e) {
        if (Number.isInteger(parseInt(e.target.value)) && parseInt(e.target.value) >= 0) {
            var obj = {};
            obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
            this.setState(obj);
        }
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        document.getElementById("pro_up").disabled = true;
        e.preventDefault();
        this.state.area = this.refs.Area.value;
        this.state.x = this.refs.Sex.value;
        Profile.checkusername(this.state.username, this.state.user.id).then(res => {
            if (res.data.status != 404) {
                this.setState({ username: '' })
                alert("このユーザー名は既に利用されています");
                return;
            } else {
                const formData = new FormData();
                formData.append('user_id', this.state.user.id)
                formData.append('profession', this.state.profession)
                formData.append('photo_id', this.state.photo_id)
                formData.append('profile_picture', this.state.profile_picture)
                formData.append('utility', this.state.utility)
                formData.append('sex', this.state.x)
                formData.append('area', this.state.area)
                formData.append('address', this.state.address)
                formData.append('username', this.state.username)
                formData.append('phone', this.state.phone)
                formData.append('email', this.state.email)
                formData.append('creditcard', this.state.creditcard)
                formData.append('t_account', this.state.t_account)
                formData.append('bank_name', this.state.bank_name)
                formData.append('branch_name', this.state.branch_name)
                formData.append('account_name', this.state.account_name)
                formData.append('account_type', this.state.account_type)
                axios({
                    method: 'post',
                    // url: 'http://192.168.1.110/sharework_back_v2/public/backend/update-basic-profile',
                    url: 'https://share-work.jp/backend/update-basic-profile',
                    data: formData,
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                }).then(res => {
                    if (res.data.message === "Success") {
                        alert("プロフィル更新されました!")
                        window.localStorage.setItem('pro_pic', JSON.stringify(res.data.profile_pic))
                        window.localStorage.setItem('pro_name', JSON.stringify(this.state.username))
                        window.location.reload()
                    }
                })
                    .catch(
                        console.log('Could not redirect!')
                    )
            }
        })

    }

    showIntroductory() {
        if (this.state.personal_text !== null) {
            return (
                this.state.personal_text.split('\n').map(function (item, key) {
                    return (
                        <span key={key}>
                            {item}
                            <br />
                        </span>
                    )
                })
            )
        } else {
            return (
                <div className="">
                    {/* {this.state.personal_text} */}
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="col-md-12" >
                            <div className="">
                                <Header />
                            </div>
                        </div>
                        <div className="mt-5 ml-5">&nbsp;</div>
                        <div>
                            <div className="mt-4 ml-5">&nbsp;</div>
                            <Modal
                                isOpen={this.state.modalIsOpen}
                                onRequestClose={this.closeModal}
                                style={customStyles}
                                contentLabel="Example Modal"
                            >

                                <div className="container" style={{ height: '375px', width: '' }}>
                                    <div className=" row" style={{ maxHeight: "100px" }}>
                                        <div className="col-md-12" style={{ textAlign: "right" }}>
                                            <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' style={{ objectFit: 'cover' }} />
                                        </div>
                                    </div>
                                    <div className="container-fluid col-md-12" style={{ padding: "1%" }}>
                                        <form>
                                            {/* <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}> */}
                                            {/* <legend style={{ width: "22%", color: "#008dc7", fontSize: "20px" }}>基本プロフィル:</legend> */}
                                            <div style={{ width: "100%", color: "#008dc7", fontSize: "10px" }}>基本プロフィル:</div>
                                            <div>&nbsp;</div>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <span style={{ fontSize: "13px" }}>プロフィル画像</span>
                                            </div>
                                            {(() => {
                                                if (this.state.profile.img === '' || this.state.profile.img === null) {
                                                    return (
                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                            <img style={{ borderRadius: "50%" }} alt="" className="rounded-circle" src={require("../../assets/images/blank.png")} style={{ height: '100px', width: '100px', objectFit: 'cover' }} />
                                                        </div>
                                                    )
                                                } else {
                                                    return (
                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                            <img style={{ borderRadius: "50%" }} alt="" className="rounded-circle" src={this.state.profile.img} style={{ height: '100px', width: '100px', objectFit: 'cover' }} />
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            <div>&nbsp;</div>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <input style={{ fontSize: "13px", width: '70%' }} type="file" onChange={this.onChangePro.bind(this)} />
                                            </div>
                                            <div>&nbsp;</div>
                                            <div style={{ fontSize: "13px" }}>職業</div>
                                            <div>
                                                <input value={this.state.profession} onChange={this.updateValue.bind(this, 'profession')}
                                                    style={{ fontSize: "13px", width: "50%", borderRadius: "3px", border: "1px solid #c7c6c6", height: "40px", padding: "2%" }} />
                                            </div>
                                            <div>&nbsp;</div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div style={{ fontSize: "13px" }}>身分証明書</div>
                                                    {(() => {
                                                        if (this.state.profile.pid === '' || this.state.profile.pid === null) {
                                                            return (
                                                                <div><img style={{ borderRadius: "50%" }} alt="" src={require("../../assets/images/default-img.png")} height="100px" width='40%' /></div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div><img alt="" src={this.state.profile.pid} height="100px" width='40%' /></div>
                                                            )
                                                        }
                                                    })()}
                                                    <div>&nbsp;</div>
                                                    <div><input style={{ fontSize: "13px" }} type="file" onChange={this.onChange.bind(this)} /></div>
                                                    <div>&nbsp;</div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div style={{ fontSize: "13px" }}>光熱費請求書</div>
                                                    {(() => {
                                                        if (this.state.profile.ut === '' || this.state.profile.ut === null) {
                                                            return (
                                                                <div><img alt="" src={require("../../assets/images/default-img.png")} height="100px" width='40%' /></div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div><img alt="" src={this.state.profile.ut} height="100px" width='40%' /></div>
                                                            )
                                                        }
                                                    })()}
                                                    <div>&nbsp;</div>
                                                    <div><input style={{ fontSize: "13px" }} type="file" onChange={this.onChange_ut.bind(this)} /></div>
                                                    <div>&nbsp;</div>
                                                </div>
                                            </div>
                                            <div style={{ fontSize: "13px" }}>性別</div>
                                            <div>
                                                <select ref="Sex" style={{ fontSize: "13px", width: "25%", height: "35px" }}
                                                    value={this.state.x} onChange={this.updateValue.bind(this, 'x')}>
                                                    <option value=''>選択して下さい</option>
                                                    {this.state.sex.map(rp =>
                                                        <option value={rp.id} key={rp.id} >
                                                            {rp.description}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div style={{ fontSize: "13px" }}>都道府県選択</div>
                                            <div>
                                                <select ref="Area" style={{ fontSize: "13px", width: "40%", height: "35px" }}
                                                    value={this.state.area} onChange={this.updateValue.bind(this, 'area')}>
                                                    <option value="">選択して下さい</option>
                                                    {this.state.residential.map(rp =>
                                                        <option value={rp.id} key={rp.id} >
                                                            {rp.area}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div style={{ fontSize: "13px" }}>住所</div>
                                            <div>
                                                <textarea style={{ fontSize: "13px", width: "70%", height: "80px", border: "1px solid gray", borderRadius: "4px", padding: "2%" }}
                                                    value={this.state.address} onChange={this.updateValue.bind(this, 'address')}>
                                                </textarea>
                                            </div>
                                            <div>&nbsp;</div>

                                            {/* </fieldset> */}
                                            <div>&nbsp;</div>
                                            {/* <fieldset style={{ border: "1px solid #008dc7", padding: "4%" }}> */}
                                            <div style={{ width: "100%", color: "#008dc7", fontSize: "10px" }}>プロフィル設定:</div>
                                            <div style={{ fontSize: "13px" }}>ユーザー名</div>
                                            <div>
                                                <input value={this.state.username} type="text" style={{
                                                    fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                    padding: "1%", fontSize: "14px"
                                                }} onChange={this.updateValue.bind(this, 'username')}></input>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div style={{ fontSize: "13px" }}>電話番号</div>
                                            <div>
                                                <input value={this.state.phone} type="number" style={{
                                                    fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                    padding: "1%", fontSize: "14px"
                                                }} onChange={this.updateValueNumber.bind(this, 'phone')}></input>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div style={{ fontSize: "13px" }}>メールアドレス</div>
                                            <div>
                                                <input value={this.state.email} type="text" style={{
                                                    fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                    padding: "1%", fontSize: "14px"
                                                }} onChange={this.updateValue.bind(this, 'email')}></input>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div style={{ fontSize: "13px" }}>銀行口座情報</div>
                                            <div>
                                                <input style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                    value={this.state.bank_name} placeholder="銀行名" onChange={this.updateValue.bind(this, 'bank_name')}>
                                                </input>
                                                {/* <input value={this.state.t_account} type="" style={{
                                                fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                padding: "1%", fontSize: "14px"
                                            }} onChange={this.updateValue.bind(this, 't_account')}></input> */}
                                            </div>
                                            <div>&nbsp;</div>
                                            <div>
                                                <input style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                    value={this.state.branch_name} placeholder="支店名" onChange={this.updateValue.bind(this, 'branch_name')}>
                                                </input>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div>
                                                <span>種類 : &nbsp;&nbsp;</span>
                                                <input type="radio" id="male" name="gender" value="1" checked={this.state.account_type === '1'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                                <label for="male">普通</label>&nbsp;&nbsp;
                                                <input type="radio" id="male" name="gender" value="2" checked={this.state.account_type === '2'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                                <label for="male">当座</label>&nbsp;&nbsp;
                                                <input type="radio" id="male" name="gender" value="3" checked={this.state.account_type === '3'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                                <label for="male">貯蓄</label>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div>
                                                <input type="number" style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                    value={this.state.t_account} placeholder="口座番号" onChange={this.updateValue.bind(this, 't_account')}>
                                                </input>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div>
                                                <input style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                    value={this.state.account_name} placeholder="口座名義" onChange={this.updateValue.bind(this, 'account_name')}>
                                                </input>
                                            </div>

                                            {/* </fieldset> */}
                                            <div>&nbsp;</div>
                                            <div style={{ textAlign: "center" }}>
                                                <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>キャンセル</button>&nbsp;
                                                <button id="pro_up" onClick={this.handleSubmit.bind(this)} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>更新する</button>
                                            </div>
                                            <div>&nbsp;</div>
                                        </form>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12" style={{ minHeight: "800px" }}>
                            <div className="row text-center">
                                <div style={{ width: '-webkit-fill-available' }}>
                                    <img className="profile-image-mobile" alt="" src={this.state.profile.img} height="140" width='140' style={{ objectFit: 'cover' }} />
                                </div>
                                <div style={{ paddingTop: "2%", width: "100%", height: '35px' }}>
                                    <h4><b><i>{this.state.profile.first_name}</i></b></h4><br />
                                </div>
                                <div style={{ paddingTop: "3%", width: '100%' }}>
                                    <button onClick={this.openModal} className="ladies-button-mobile" style={{ border: "1px solid" }}>基本情報を編集する</button><br />
                                    <Link to={{
                                        pathname: `/my-profile-view/users/${this.state.user.id}`,
                                        state: { id: this.state.user.id }
                                    }}  >
                                        <button style={{ border: "1px solid" }} className="view-profile_ex mt-3 ladies-button-mobile">自分のページを見る</button>
                                    </Link>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-2"></div>
                                <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", minHeight: "200px", borderRadius: '5px' }}>
                                    <div>
                                        {this.showIntroductory()}
                                    </div>
                                    <br />
                                    <br />
                                    <div style={{ textAlign: "center" }}>
                                        <Link className="sky-a" to={{
                                            pathname: `/seller-edit-intro`,
                                        }}>
                                            紹介文を編集する
                                            </Link>
                                    </div>
                                </div>
                                <div className="col-md-2"></div>
                            </div>

                            {/* personal information display section 1*/}
                            <div className="row mt-5">
                                <div className="col-md-2"></div>
                                <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", minHeight: "200px", borderRadius: '5px' }}>
                                    <div className="col-12 row">
                                        <div className="col-5  personal-info-mobile">性別: </div>
                                        <div className="col-7  personal-info-mobile">{this.state.profile.sx}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5  personal-info-mobile">都道府県選択: </div>
                                        <div className="col-7  personal-info-mobile">{this.state.profile.area}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5  personal-info-mobile" style={{ textAlign: "left" }}>住所: </div>
                                        <div className="col-7  personal-info-mobile" style={{ textAlign: "left" }}>
                                            {(() => {
                                                if (this.state.address !== null) {
                                                    return (
                                                        this.state.address.split('\n').map((item, key) =>
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        ))
                                                }
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2"></div>
                            </div>

                            {/* personal information display section 2*/}
                            <div className="row mt-5">
                                <div className="col-md-2"></div>
                                <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", minHeight: "200px", borderRadius: '5px' }}>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile" >ユーザー名: </div>
                                        <div className="col-7 personal-info-mobile" >{this.state.username}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile">電話番号: </div>
                                        <div className="col-7 personal-info-mobile">{this.state.phone}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile" >メールアドレス: </div>
                                        <div className="col-7 personal-info-mobile" >{this.state.email}</div>
                                    </div>
                                    <div className="col-md-12 m-2 text-center">銀行口座情報</div>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile">銀行名 : </div>
                                        <div className="col-7 personal-info-mobile">{this.state.bank_name}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile">支店名 : </div>
                                        <div className="col-7 personal-info-mobile">{this.state.branch_name}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile">口座番号 : </div>
                                        <div className="col-7 personal-info-mobile">{this.state.t_account}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile">口座名義 : </div>
                                        <div className="col-7 personal-info-mobile">{this.state.account_name}</div>
                                    </div>
                                    <div className="col-12 row">
                                        <div className="col-5 personal-info-mobile">種類 : </div>
                                        <div className="col-7 personal-info-mobile">
                                            {(() => {
                                                if (this.state.account_type == '1') {
                                                    return (
                                                        <div>普通</div>
                                                    )
                                                } else if (this.state.account_type == '2') {
                                                    return (
                                                        <div>当座</div>
                                                    )
                                                } else {
                                                    return (
                                                        <div>貯蓄</div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2"></div>
                            </div>


                            <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                <div className="col-md-1"></div>
                                <div className="col-md-5" style={{ textAlign: "left" }}>
                                    <h3>ポートフォリオ</h3>
                                </div>
                                <div className="col-md-5" style={{ textAlign: "left" }}>
                                    <Link to={{
                                        pathname: `/my-portfolio`,
                                    }}>
                                        <span className="sky-a"><b>すべて見る</b></span>
                                    </Link>
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                            {(() => {
                                if (this.state.portfolio.length === 0) {
                                    return (
                                        <div></div>
                                    )
                                } else {
                                    return (
                                        <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                            <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                {this.state.portfolio.map(group =>
                                                    <div className="col-md-3" style={{ padding: "2%" }}>
                                                        <div><img style={{ height: "200px", width: "200px" }} src={group.img}></img></div>
                                                        <div>{group.title.substring(0, 20)}...</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            })()}
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8" style={{ backgroundColor: "#fafafa", height: "300px", textAlign: "center", padding: "4%" }}>
                                    <h3>ポートフォリオを投稿しましょう</h3>
                                    <br />
                                    <p>あなたがポートフォリオや作品を提出するとき、あなたの魅力は直接伝達されます。あなたの作品を投稿してアピー​​ルしましょう。</p><br />
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/seller-edit-portfolio`,
                                    }}>
                                        <span className="sky-a"><b>最初の作品を投稿する</b></span>
                                    </Link>
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12" >
                                <div className="">
                                    <Header />
                                </div>
                            </div>
                            <div className="mt-5 ml-5">&nbsp;</div>
                            <div className="mt-4 ml-5">&nbsp;</div>
                            <div>
                                <Modal
                                    isOpen={this.state.modalIsOpen}
                                    onAfterOpen={this.afterOpenModal}
                                    onRequestClose={this.closeModal}
                                    style={customStyles}
                                    contentLabel="Example Modal"
                                >
                                    <div style={{ width: "950px", height: "475px", overflow: "auto" }}>
                                        <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                            <div className="col-md-12" style={{ textAlign: "right" }}>
                                                <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' style={{ objectFit: 'cover' }} />
                                            </div>
                                        </div>
                                        <div style={{ padding: "1%" }}>
                                            <form>
                                                <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                                    <legend style={{ width: "22%", color: "#008dc7", fontSize: "20px" }}>基本プロフィル:</legend>
                                                    <div>&nbsp;</div>
                                                    <div style={{ width: "100%", textAlign: "center" }}>
                                                        <span style={{ fontSize: "13px" }}>プロフィル画像</span>
                                                    </div>
                                                    {(() => {
                                                        if (this.state.profile.img === '' || this.state.profile.img === null) {
                                                            return (
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                    <img style={{ borderRadius: "50%" }} alt="" className="rounded-circle" src={require("../../assets/images/blank.png")} style={{ height: '180px', width: '25%', objectFit: 'cover' }} />
                                                                </div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                    <img style={{ borderRadius: "50%" }} alt="" className="rounded-circle" src={this.state.profile.img} style={{ height: '180px', width: '25%', objectFit: 'cover' }} />
                                                                </div>
                                                            )
                                                        }
                                                    })()}
                                                    <div>&nbsp;</div>
                                                    <div style={{ width: "100%", textAlign: "center", paddingLeft: "15%" }}>
                                                        <input style={{ fontSize: "13px" }} type="file" onChange={this.onChangePro.bind(this)} />
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div style={{ fontSize: "13px" }}>職業</div>
                                                    <div>
                                                        <input value={this.state.profession} onChange={this.updateValue.bind(this, 'profession')}
                                                            style={{ fontSize: "13px", width: "50%", borderRadius: "3px", border: "1px solid #c7c6c6", height: "40px", padding: "2%" }} />
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div className="col-md-12 row">
                                                        <div className="col-md-6">
                                                            <div style={{ fontSize: "13px" }}>身分証明書</div>
                                                            {(() => {
                                                                if (this.state.profile.pid === '' || this.state.profile.pid === null) {
                                                                    return (
                                                                        <div><img style={{ borderRadius: "50%" }} alt="" src={require("../../assets/images/default-img.png")} height="100px" width='40%' /></div>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <div><img alt="" src={this.state.profile.pid} height="100px" width='40%' /></div>
                                                                    )
                                                                }
                                                            })()}
                                                            <div>&nbsp;</div>
                                                            <div><input style={{ fontSize: "13px" }} type="file" onChange={this.onChange.bind(this)} /></div>
                                                            <div>&nbsp;</div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div style={{ fontSize: "13px" }}>光熱費請求書</div>
                                                            {(() => {
                                                                if (this.state.profile.ut === '' || this.state.profile.ut === null) {
                                                                    return (
                                                                        <div><img alt="" src={require("../../assets/images/default-img.png")} height="100px" width='40%' /></div>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <div><img alt="" src={this.state.profile.ut} height="100px" width='40%' /></div>
                                                                    )
                                                                }
                                                            })()}
                                                            <div>&nbsp;</div>
                                                            <div><input style={{ fontSize: "13px" }} type="file" onChange={this.onChange_ut.bind(this)} /></div>
                                                            <div>&nbsp;</div>
                                                        </div>
                                                    </div>
                                                    <div style={{ fontSize: "13px" }}>性別</div>
                                                    <div>
                                                        <select ref="Sex" style={{ fontSize: "13px", width: "25%", height: "35px" }}
                                                            value={this.state.x} onChange={this.updateValue.bind(this, 'x')}>
                                                            <option value=''>選択して下さい</option>
                                                            {this.state.sex.map(rp =>
                                                                <option value={rp.id} key={rp.id} >
                                                                    {rp.description}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div style={{ fontSize: "13px" }}>都道府県選択</div>
                                                    <div>
                                                        <select ref="Area" style={{ fontSize: "13px", width: "40%", height: "35px" }}
                                                            value={this.state.area} onChange={this.updateValue.bind(this, 'area')}>
                                                            <option value="">選択して下さい</option>
                                                            {this.state.residential.map(rp =>
                                                                <option value={rp.id} key={rp.id} >
                                                                    {rp.area}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div style={{ fontSize: "13px" }}>住所</div>
                                                    <div>
                                                        <textarea style={{ fontSize: "13px", width: "70%", height: "80px", border: "1px solid gray", borderRadius: "4px", padding: "2%" }}
                                                            value={this.state.address} onChange={this.updateValue.bind(this, 'address')}>
                                                        </textarea>
                                                    </div>
                                                    <div>&nbsp;</div>

                                                </fieldset>
                                                <div>&nbsp;</div>
                                                <fieldset style={{ border: "1px solid #008dc7", padding: "4%" }}>
                                                    <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>プロフィル設定:</legend>
                                                    <div style={{ fontSize: "13px" }}>ユーザー名</div>
                                                    <div>
                                                        <input value={this.state.username} type="text" style={{
                                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                            padding: "1%", fontSize: "14px"
                                                        }} onChange={this.updateValue.bind(this, 'username')}></input>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div style={{ fontSize: "13px" }}>電話番号</div>
                                                    <div>
                                                        <input value={this.state.phone} type="number" style={{
                                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                            padding: "1%", fontSize: "14px"
                                                        }} onChange={this.updateValueNumber.bind(this, 'phone')}></input>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div style={{ fontSize: "13px" }}>メールアドレス</div>
                                                    <div>
                                                        <input value={this.state.email} type="text" style={{
                                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                            padding: "1%", fontSize: "14px"
                                                        }} onChange={this.updateValue.bind(this, 'email')}></input>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    {/* <div style={{ fontSize: "13px" }}>クレジットカード</div>
                                                <div>
                                                    <input value={this.state.creditcard} type="" style={{
                                                        fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                        padding: "1%", fontSize: "14px"
                                                    }} onChange={this.updateValue.bind(this, 'creditcard')}></input>
                                                </div> */}
                                                    <div style={{ fontSize: "13px" }}>銀行口座情報</div>
                                                    <div>
                                                        <input type="text" style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                            value={this.state.bank_name} placeholder="銀行名" onChange={this.updateValue.bind(this, 'bank_name')}>
                                                        </input>
                                                        {/* <input value={this.state.t_account} type="" style={{
                                                        fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                                        padding: "1%", fontSize: "14px"
                                                    }} onChange={this.updateValue.bind(this, 't_account')}></input> */}
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div>
                                                        <input type="text" style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                            value={this.state.branch_name} placeholder="支店名" onChange={this.updateValue.bind(this, 'branch_name')}>
                                                        </input>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div>
                                                        <span>種類 : &nbsp;&nbsp;</span>
                                                        <input type="radio" id="male" name="gender" value="1" checked={this.state.account_type === '1'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                                        <label for="male">普通</label>&nbsp;&nbsp;
                                                        <input type="radio" id="male" name="gender" value="2" checked={this.state.account_type === '2'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                                        <label for="male">当座</label>&nbsp;&nbsp;
                                                        <input type="radio" id="male" name="gender" value="3" checked={this.state.account_type === '3'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                                        <label for="male">貯蓄</label>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div>
                                                        <input type="number" style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                            value={this.state.t_account} placeholder="口座番号" onChange={this.updateValue.bind(this, 't_account')}>
                                                        </input>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div>
                                                        <input type="text" style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                                            value={this.state.account_name} placeholder="口座名義" onChange={this.updateValue.bind(this, 'account_name')}>
                                                        </input>
                                                    </div>

                                                </fieldset>
                                                <div>&nbsp;</div>
                                                <div style={{ textAlign: "center" }}>
                                                    <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>キャンセル</button>&nbsp;
                                                <button id="pro_up" onClick={this.handleSubmit.bind(this)} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>更新する</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                            {/* <div className="col-md-12"> */}
                            <div className="container" style={{ minHeight: "800px" }}>
                                {/* <div className="col-md-12">
                                <img alt="" style={{ backgroundColor: "#f1f0ee", border: "none" }} height="440" width='1000' />
                                <button style={{ width: "20px", backgroundColor: "green" }}>here</button>
                            </div> */}
                                <div className="row">
                                    <div className="ml-5">
                                        <img className="profile-image" alt="" src={this.state.profile.img} height="140" width='140' style={{ objectFit: 'cover' }} />
                                    </div>
                                    <div style={{ paddingLeft: "19%", paddingTop: "2%", width: "70%" }}>
                                        <h4><b><i>{this.state.profile.first_name}</i></b></h4><br />
                                    </div>
                                    <div style={{ paddingTop: "3%" }}>
                                        <button onClick={this.openModal} className="ladies-button" style={{ border: "1px solid" }}>基本情報を編集する</button><br />
                                        <div>&nbsp;</div>
                                        <Link to={{
                                            pathname: `/my-profile-view/users/${this.state.user.id}`,
                                            state: { id: this.state.user.id }
                                        }}>
                                            <button style={{ border: "1px solid" }} className="view-profile_ex ladies-button">自分のページを見る</button>
                                        </Link>

                                    </div>
                                </div>
                                <div>&nbsp;</div>

                                {/* introductory text and edit button section */}
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", minHeight: "200px", borderRadius: '5px' }}>
                                        <div>
                                            {this.showIntroductory()}
                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                        <div style={{ textAlign: "center" }}>
                                            <Link className="sky-a" to={{
                                                pathname: `/seller-edit-intro`,
                                            }}>
                                                紹介文を編集する
                                        </Link>
                                        </div>

                                    </div>
                                    <div className="col-md-2"></div>
                                </div>

                                {/* personal information display section 1*/}
                                <div className="row mt-5">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", minHeight: "200px", borderRadius: '5px' }}>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>性別: </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.profile.sx}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>都道府県選択: </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.profile.area}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>住所: </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {(() => {
                                                    if (this.state.address !== null) {
                                                        return (
                                                            this.state.address.split('\n').map((item, key) =>
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            ))
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>



                                {/* personal information display section 2*/}
                                <div className="row mt-5">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", minHeight: "200px", borderRadius: '5px' }}>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>ユーザー名: </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.username}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>電話番号: </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.phone}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>メールアドレス: </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.email}</div>
                                        </div>
                                        <div className="col-md-12 m-2 text-center">銀行口座情報</div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>銀行名 : </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.bank_name}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>支店名 : </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.branch_name}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>口座番号 : </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.t_account}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>口座名義 : </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>{this.state.account_name}</div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>種類 : </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {(() => {
                                                    if (this.state.account_type == '1') {
                                                        return (
                                                            <div>普通</div>
                                                        )
                                                    } else if (this.state.account_type == '2') {
                                                        return (
                                                            <div>当座</div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div>貯蓄</div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>


                                {/* service list section */}
                                <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                    <div className="col-md-1"></div>
                                    <div className="col-md-5" style={{ textAlign: "left" }}>
                                        <h3>ポートフォリオ</h3>
                                    </div>
                                    <div className="col-md-5" style={{ textAlign: "right" }}>
                                        <Link to={{
                                            pathname: `/my-portfolio`,
                                        }}>
                                            <span className="sky-a"><b>すべて見る</b></span>
                                        </Link>
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                                {(() => {
                                    if (this.state.portfolio.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                                <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                    {this.state.portfolio.map(group =>
                                                        <div className="col-md-3" style={{ padding: "2%" }}>
                                                            <div><img style={{ height: "200px", width: "200px" }} src={group.img}></img></div>
                                                            <div>{group.title.substring(0, 20)}...</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                })()}
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ backgroundColor: "#fafafa", height: "300px", textAlign: "center", padding: "4%" }}>
                                        <h3>ポートフォリオを投稿しましょう</h3><br />
                                        <p>あなたがポートフォリオや作品を提出するとき、あなたの魅力は直接伝達されます。あなたの作品を投稿してアピー​​ルしましょう。</p><br /><br />
                                        <Link style={{ color: "#777272" }} to={{
                                            pathname: `/seller-edit-portfolio`,
                                        }}>
                                            <span className="sky-a"><b>最初の作品を投稿する</b></span>
                                        </Link>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className=" mt-5" >
                        <div className=" mt-5">
                            <Footer />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { EditProfileNav };